import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { readableColor } from "polished"

const getSize = (size) => {
  switch (size) {
    case "small":
      return "3rem"
    case "standard":
      return "4rem"
    case "medium":
      return "7rem"
    case "large":
      return "9rem"
    default:
      return "140px"
  }
}

const getFontSize = (size) => {
  switch (size) {
    case "small":
      return "1.35rem"
    case "medium":
      return "3.5rem"
    case "large":
      return "4.5rem"
    default:
      return "2.5rem"
  }
}

const sizes = css`
  min-width: ${({ size }) => getSize(size)};
  max-width: ${({ size }) => getSize(size)};
  min-height: ${({ size }) => getSize(size)};
  max-height: ${({ size }) => getSize(size)};
`

const fontSizes = css`
  font-size: ${({ size }) => getFontSize(size)};
`

export const ImgWrapper = styled.div`
  margin: 0;
  padding: 0;
  border: 2px solid white;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.primary};

  ${({ plain }) =>
    plain &&
    css`
      border-color: transparent;
    `}

  ${({ smallOnMobile }) =>
    smallOnMobile &&
    css`
      width: 124px;
      height: 124px;
      border-width: 1px;

      ${breakpoint("tablet")`
      ${sizes}
      border-width: 2px;
    `}
    `}

  ${({ smallOnMobile, size }) =>
    !smallOnMobile &&
    size !== "large" &&
    css`
      ${sizes}
    `}

    ${({ smallOnMobile, size }) =>
    !smallOnMobile &&
    size == "large" &&
    css`
      width: 5rem;
      height: 5rem;

      ${breakpoint("tablet")`
        width: 6rem;
        height: 6rem;
      `}

      ${breakpoint("desktop")`
          width: 9rem;
          height: 9rem;
      `}
    `}
`

export const Img = styled.img`
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: white;

  ${({ obfuscated }) =>
    !!obfuscated &&
    css`
      filter: blur(8px);
      pointer-events: none;
    `}
`

export const Div = styled.div`
  border: 2px solid white;
  border-radius: 50%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.secondary};

  ${({ profile }) =>
    !!profile &&
    css`
      background-color: ${({ theme }) => theme.colors.profile.avatarBackground};
    `}

  ${({ noBorder }) =>
    !!noBorder &&
    css`
      border: none;
    `}

  ${({ plain }) =>
    plain &&
    css`
      border-color: transparent;
    `}

  ${({ smallOnMobile }) =>
    !!smallOnMobile &&
    css`
      width: 124px;
      height: 124px;
      border-width: 1px;

      ${breakpoint("tablet")`
      ${sizes}
      border-width: 2px;
    `}
    `}

    ${({ smallOnMobile, size }) =>
    !smallOnMobile &&
    size !== "large" &&
    css`
      ${sizes}
    `}

      ${({ smallOnMobile, size }) =>
    !smallOnMobile &&
    size == "large" &&
    css`
      width: 5rem;
      height: 5rem;

      ${breakpoint("tablet")`
          width: 6rem;
          height: 6rem;
        `}

      ${breakpoint("desktop")`
            width: 9rem;
            height: 9rem;
        `}
    `}
`

export const P = styled.p`
  font-family: Helvetica Neue;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.bodyAlternative || theme.colors.body};

  ${({ profile }) =>
    !!profile &&
    css`
      color: white;
    `}

  ${({ smallOnMobile }) =>
    !!smallOnMobile &&
    css`
      font-size: ${() => getFontSize("small")};

      ${breakpoint("tablet")`
        ${fontSizes}
      `}
    `}

  ${({ smallOnMobile, size }) =>
    !smallOnMobile &&
    size != "large" &&
    css`
      ${fontSizes}
    `}

      ${({ smallOnMobile, size }) =>
    !smallOnMobile &&
    size == "large" &&
    css`
      font-size: 1.25rem;

      ${breakpoint("tablet")`
        font-size: 2rem;
      `}

      ${breakpoint("desktop")`
        font-size: 4.5rem;
      `}
    `}
`
